import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        online: true,
    },
    getters: {
        online: state => state.online,
    },
    mutations: {
        online(state, status) {
            state.online = status;
        }
    },
    actions: {
    },
}
